// Single source of truth for the product name. Change it here and it updates
// across the app (nav, auth screens, landing, footer).
export const BRAND = 'Cadence';
